import React from "react";

export interface VisibilityContextValue {
  visible: boolean;
}

const VisibilityContext = React.createContext<VisibilityContextValue>({
  visible: true,
});

export const useVisibility = () => {
  return React.useContext(VisibilityContext);
};

export const VisibilityProvider = VisibilityContext.Provider;
